<template>
	<div>
		<v-row class="my-3">
			<v-col cols="2" sm="2" md="1" lg="1" xl="1" class="py-1">
				<h4>Item</h4>
				<span>{{ itemSelecionado.item }}</span>
			</v-col>
			<v-col cols="3" sm="2" md="2" lg="2" xl="2" class="py-1">
				<h4>Tipo</h4>
				<span>{{ itemSelecionado.tipo }}</span>
			</v-col>
			<v-col cols="4" sm="6" md="6" lg="6" xl="6" class="py-1">
				<h4>Descrição</h4>
				<texto-tooltip :texto="itemSelecionado.descricao" :tamanho-maximo="textoTamanhoMaximo"></texto-tooltip>
			</v-col>
			<v-col cols="3" sm="2" md="2" lg="2" xl="2" class="py-1">
				<h4>Saldo Total</h4>
				<span>{{ itemSelecionado.estoqueInicial + (itemSelecionado.valorAcrescido || 0) - (itemSelecionado.valorSuprimido || 0) | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
			</v-col>
		</v-row>

		<v-divider></v-divider>

		<div class="my-3">
			<v-row>
				<v-col cols="12" sm="12" class="flex-column d-flex justify-sm-start">
					<v-scroll-x-transition>
						<acessar-transferencia-listagem
							v-if="isListagem"
							:total-paginas="listagem.totalPaginas"
							:total-itens="listagem.totalItens"
							:paginacao="listagem.paginacao"
							:itens="listagem.datasource"
							@paginar="paginarListagem"
							@resetar-page="resetarPaginaListagem"
							@transferir-saldo="transferir"
						></acessar-transferencia-listagem>
						<transferir v-if="!isListagem" @recarregar-listagem="recarregarListagem"></transferir>
					</v-scroll-x-transition>
				</v-col>
			</v-row>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { actionTypes, mutationTypes } from '@/core/constants'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import AcessarTransferenciaListagem from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/gerenciar-estoque/transferencia/listagem/AcessarTransferenciaListagem.vue'
import PaginacaoListagem from '@/core/store/default/paginacaoListagem'
import Transferir from '@/views/pages/ata/acessar/gestao-da-ata/itens/listagem/gerenciar-estoque/transferencia/transferir/Transferir.vue'
import TextoTooltip from '@/views/components/TextoTooltip.vue'

export default {
	name: 'transferencia',
	components: { TextoTooltip, Transferir, AcessarTransferenciaListagem },
	mixins: [validacaoFormulario],
	props: {
		isListagem: {
			type: Boolean,
		},
	},
	data() {
		return {
			listagem: {
				totalItens: 0,
				totalPaginas: 0,
				paginacao: PaginacaoListagem(['seq']),
				datasource: [],
			},
			textoTamanhoMaximo: 250,
		}
	},
	computed: {
		...mapState({
			itemSelecionado: (state) => state.itemAta.itemSelecionado,
			idOrgaoCedente: (state) => state.itemAta.transferencia.transferir.orgaoCedente.idUo,
			paginacao: (state) => state.itemAta.transferencia.transferir.paginacao,
			datasource: (state) => state.itemAta.transferencia.transferir.datasource,
			totalItens: (state) => state.itemAta.transferencia.transferir.totalElements,
			totalPaginas: (state) => state.itemAta.transferencia.transferir.totalPages,
		}),
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisQtde
			},
		},
	},
	watch: {
		paginacao: {
			handler(novoValor) {
				this.setPaginacao(novoValor)
			},
			deep: true,
		},
		isListagem() {
			this.buscarEstoqueDosOrgaos()
		},
	},
	async mounted() {
		await this.buscarEstoqueDosOrgaos()
	},
	methods: {
		async buscarEstoqueDosOrgaos() {
			let { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.BUSCAR_ESTOQUE_ORGAOS,
				this.itemSelecionado.id,
			)

			this.listagem.datasource = itens
			this.listagem.totalItens = totalElements
			this.listagem.totalPaginas = totalPages
		},
		resetarPaginaListagem() {
			this.$store.commit(mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.RESETAR_PAGINA_LISTAGEM)
		},
		setPaginacao(paginacao) {
			this.$store.commit(mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.SET_PAGINACAO_LISTAGEM, paginacao)
		},
		async paginarListagem(paginacao) {
			this.setPaginacao(paginacao)
			await this.buscarEstoqueDosOrgaos()
		},
		async transferir(orgao) {
			this.$store.commit(mutationTypes.ITEM_ATA.TRANSFERENCIA.TRANSFERIR.SET_ORGAO_CEDENTE, orgao)
			this.$emit('recarregar-listagem')
			this.$emit('mudar-estado-botao-salvar', 1, this.idOrgaoCedente, orgao.tipoAlteracaoSaldo)
		},
		recarregarListagem() {
			this.$emit('recarregar-listagem')
			this.$emit('mudar-estado-botao-salvar', 1, this.idOrgaoCedente)
		},
	},
}
</script>
